// extracted by mini-css-extract-plugin
export var dropdownIcon = "_q5-6";
export var imgContainer = "_q5-3";
export var menuIcon = "_q5-5";
export var pillWrapper = "_q5-2";
export var pillsContainer = "_q5-1";
export var subscriptionCard = "_q5-0";
export var subscriptionLogo = "_q5-4";